export interface ValidateDirectDebitDetailsRequest {
  branch_code: string;
  account_number: string;
}

export interface ValidateDirectDebitDetailsResponse {
  is_valid: boolean;
}
